import type { LogLevel } from "../domain/error/errors.ts";
import { isTestEnv } from "../utils/envs.shared.ts";
import { isBrowser } from "../utils/is-browser.ts";

export interface AlertDevsParams {
  message: string;
  exception?: unknown;
  context?: Record<string, unknown>;
  /** Log level - only used by backend (defaults to "error") */
  level?: LogLevel;
}

export function alertDevs(params: AlertDevsParams): void {
  const { message, exception, context, level } = params;
  if (isTestEnv()) {
    throw new Error("\n🚨 alertDevs was called in a test without being mocked\n");
  }

  if (isBrowser()) {
    void import("./sentry-front.ts").then(({ alertDevs: alertDevsFront }) => {
      alertDevsFront({
        error: exception instanceof Error ? exception : new Error(message),
        exception: message,
        context,
      });
      return;
    });
    return;
  }

  void import("./sentry-back.ts").then(({ alertDevs: alertDevsBack }) => {
    alertDevsBack({
      message,
      exception,
      context,
      level,
    });
    return;
  });
}
